import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '~~utils/CommonUtils';
import { TABLET_WIDTH } from '~~elements/Const';

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .season-header {
    &--name {
      font-size: 1.2rem;
    }
    &--change {
      color: #aaaaaa;
      display: flex;
      align-items: center;
      font-size: 0.8rem;

      select,
      option {
        color: #aaaaaa;
        &:hover,
        &:focus {
          display: inline-block;
        }
      }

      &-hint {
        font-size: 0.8rem;
        margin-left: 3rem;
      }
      select {
        display: none;
      }

      &:hover,
      &:focus {
        select {
          display: inline-block;
        }
      }
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    flex-direction: column;
    text-align: center;
    align-items: center;
    .season-header {
      &--change-hint {
        margin-left: 0;
      }
    }
  }
`;

const LeagueSeasonHeader = ({ seasons, seasonIndex, setSeasonIndex }) => {
  const query = useQuery();
  useEffect(() => {
    if (!seasons[seasonIndex]) {
      query.delete('lsindex');
      setSeasonIndex(0);
      return;
    }

    const lsindex = query.get('lsindex');
    const querySeasonIndex = parseInt(lsindex);
    if (!lsindex || querySeasonIndex === seasonIndex) {
      return;
    }

    if (Number.isNaN(querySeasonIndex) || querySeasonIndex < 0 || querySeasonIndex > seasons.length - 1) {
      return query.delete('lsindex');
    }

    setSeasonIndex(querySeasonIndex);
  }, [query, seasonIndex, seasons, setSeasonIndex]);

  const handleSeasonChange = (e) => {
    query.set({ lsindex: e.target.value });
  };

  if (seasons.length === 0 || !seasons[seasonIndex]) {
    return <></>;
  }

  return (
    <StyledDiv>
      <div>
        <div className="season-header--name">{seasons[seasonIndex].title}</div>
      </div>
      {seasons.length > 1 && (
        <label className="season-header--change" tabIndex="-1">
          <div className="season-header--change-hint">切換</div>
          <select value={seasonIndex} onChange={handleSeasonChange}>
            {seasons.map((season, index) => (
              <option key={index} value={index}>
                {season.title}
              </option>
            ))}
          </select>
        </label>
      )}
    </StyledDiv>
  );
};

export default LeagueSeasonHeader;
